
export function stripAccents(str: string | null | undefined): string {
    if (!str) {
        return '';
    }

    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}


export function containsIgnoreCaseAndAccent(
    text: string | null | undefined,
    search: string | null | undefined
): boolean {
    if (!text || !search) {
        return false;
    }

    const normalizedText = stripAccents(text).toLowerCase();
    const normalizedSearch = stripAccents(search).toLowerCase();

    return normalizedText.includes(normalizedSearch);
}


export function equalsIgnoreCaseAndAccent(
    str1: string | null | undefined,
    str2: string | null | undefined
): boolean {
    if (!str1 && !str2) {
        return true;
    }
    if (!str1 || !str2) {
        return false;
    }

    return stripAccents(str1).toLowerCase() === stripAccents(str2).toLowerCase();
}

